<script setup lang="ts">
import type { PageLogosProps } from '#ui/types';
import lodashOmit from 'lodash-es/omit';
import lodashPick from 'lodash-es/pick';

export interface StoryblokUiPageLogosProps {
    blok: StoryblokUiPageLogos;
}

// PROPS
const { blok } = defineProps<StoryblokUiPageLogosProps>();

// DATA
const { classes } = useStoryblokComponentClass(() => lodashPick(blok, ['anchorId']));
const { classes: marqueeClasses } = useStoryblokComponentClass(() => ({ duration: blok.marqueeDuration }));
const pageLogosProps = computed<PageLogosProps>(() =>
    lodashOmit(storyblokOmitEmptyValues<StoryblokUiPageLogos>(blok), ['_uid', 'component', 'items', 'marquee'])
);
const ui = computed(() => {
    if (blok.marquee) {
        return {};
    }

    return {
        logos: 'w-full overflow-x-auto scrollbar-hide',
    };
});
const marquee = computed(() => {
    if (blok.marquee) {
        return {
            class: marqueeClasses.value,
        };
    }

    return false;
});
</script>

<template>
    <BaseWidthContainer :id="blok.anchorId" v-editable="blok" class="my-6 space-y-8 sm:my-8 xl:my-14" :class="classes">
        <UPageLogos v-bind="pageLogosProps" :marquee="marquee" :ui="ui">
            <template v-if="blok.items?.length" #default>
                <StoryblokComponent v-for="item in blok.items" :key="item._uid" :blok="item" />
            </template>
        </UPageLogos>
    </BaseWidthContainer>
</template>
